import WPAPIService from "../../wp-rest/posts";
import "./channel-listing-component.scss";

import CategorySelectComponent from "../category-select/category-select-component";
import SearchComponent from "../search/search-component";
import PaginationComponent from "../pagination/pagination-component";

const { useState } = wp.element;

function ChannelListings() {
  const [category, setCategory] = useState("22,23,24,25,26");
  let categoryCallback = (newCategory) => {
    setCategory(newCategory);
    setCurrentPage(1);
  };
  const [search, setSearch] = useState("");
  let searchCallback = (newSearch) => {
    setSearch(newSearch);
  };

  const [currentPage, setCurrentPage] = useState(1);
  let paginationCallback = (newPage) => {
    setCurrentPage(newPage);
  };

  let postsURL =
    "/wp-json/wp/v2/channel?_embed&per_page=30&package=" +
    category +
    "&page=" +
    currentPage +
    "&order=asc";
  const unsortedChannels = WPAPIService(postsURL);
  var channels = [];
  if (unsortedChannels[0] !== null) {
    channels = unsortedChannels[0].sort(
      (a, b) => parseInt(a.acf.channel_number) - parseInt(b.acf.channel_number)
    );
  }
  return (
    <div className={"channel-listings-react" + (unsortedChannels[3] ? " loading" : "")}>
      <div className="row">
        <SearchComponent searchCallback={searchCallback} />
      </div>
      <div className="row">
        <CategorySelectComponent channelCategoryCallback={categoryCallback} />
      </div>
      <div className="row">
        {channels &&
          channels.map((channel, index) => (
            <div className="col-12 col-sm-6 col-md-4" key={index}>
              <div className="single-channel">
                <div className="channel-number">{channel.acf.channel_number}</div>
                <div
                  className="channel-name"
                  dangerouslySetInnerHTML={{ __html: channel.title.rendered }}
                ></div>
              </div>
            </div>
          ))}
      </div>
      <div className="row">
        <PaginationComponent
          totalPages={unsortedChannels[1]}
          totalPosts={unsortedChannels[2]}
          channelCurrentPage={currentPage}
          channelPaginationCallback={paginationCallback}
        />
      </div>
    </div>
  );
}

export default ChannelListings;



// WEBPACK FOOTER //
// ./react/components/channel-listing/channel-listing-component.jsx